import { render, staticRenderFns } from "./PointsTable.vue?vue&type=template&id=602396e0&scoped=true"
import script from "./PointsTable.vue?vue&type=script&lang=js"
export * from "./PointsTable.vue?vue&type=script&lang=js"
import style0 from "./PointsTable.vue?vue&type=style&index=0&id=602396e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602396e0",
  null
  
)

export default component.exports